import { render, staticRenderFns } from "./FullScreenPlayer.vue?vue&type=template&id=8c36cbac&scoped=true&lang=pug&"
import script from "./FullScreenPlayer.vue?vue&type=script&lang=js&"
export * from "./FullScreenPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenPlayer.vue?vue&type=style&index=0&id=8c36cbac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c36cbac",
  null
  
)

export default component.exports